import { render, staticRenderFns } from "./RegisterPet.vue?vue&type=template&id=f1e1b71a&scoped=true&"
import script from "./RegisterPet.vue?vue&type=script&lang=js&"
export * from "./RegisterPet.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPet.vue?vue&type=style&index=0&id=f1e1b71a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e1b71a",
  null
  
)

export default component.exports